// SuperDernek configuration
export const superdernekConfig = {
    // Tenant bilgileri
    tenantId: "superdernek",
    tenantName: "SüperDernek",

    // Site bilgileri
    siteName: "SuperDernek - Dernekler İçin Dijital Çözümler",
    siteSlogan: "Dernekler İçin Dijital Çözümler",
    siteDescription: "E-imza, KEP ve kurumsal dijital dönüşüm hizmetleri",
    siteUrl: "https://superdernek.com",

    // Logo
    logo: {
        main: "/assets/super_dernek.webp",
    },

    widget_video_url: "/assets/videos/animation.mp4",

    // Renkler
    colors: {
        primary: "#1ac8ff", // Koyu mavi - kurumsal
        secondary: "#fda832", // Turuncu - enerji
        accent: "#37474F" // Koyu gri
    },

    headerColors: {
        primary: "#0D47A1",
        linkBackground: "#0D47A12e",
        default: "#4b5563",
        textColor: '#374151',
        applyButton: "linear-gradient(to right, #0D47A1, #1565C0)",
        applyButtonHover: "linear-gradient(to right, #0A3D7A, #0D47A1)",
        dealerButton: "linear-gradient(to right, #FF6F00, #F57C00)",
        dealerButtonHover: "linear-gradient(to right, #E65100, #EF6C00)"
    },


    homePage: {
        hero: {
            primary: '#0D47A1',
            chipColor: "linear-gradient(to bottom right, #0D47A1, #1565C0)",
            bottomGradient: "linear-gradient(to bottom right, #0D47A1, #1976D2)",
            boxShadow: '0 10px 20px rgba(13, 71, 161, 0.3)',
            bgColor: "rgba(13, 71, 161, 0.15)",
            statsIconBgColor: "rgba(255,255,255,0.1)"
        },
        products: {
            primary: '#0D47A1',
            chipBackground: '#0D47A11a',
            cardHoverBorder: '#0D47A196',
            buttonColor: '#0D47A1',
            buttonBorder: '#0D47A1'
        },
        useCases: {
            primary: '#0D47A1',
            chipBackground: '#0D47A11a',
            iconBackground: '#0D47A11a',
            countChipBackground: '#0D47A11a',
            countChipColor: '#0D47A1',
            bgGradient: 'linear-gradient(to bottom right, #0D47A103, #1565C00a)'
        },
        benefits: {
            primary: '#0D47A1',
            chipBackground: '#0D47A11a',
            cardBorder: '#0D47A1',
            iconColor: '#0D47A1'
        },
        features: {
            primary: '#0D47A1',
            chipBackground: '#0D47A11a',
            iconBackground: '#0D47A115',
            cardHoverBorder: '#0D47A1',
            iconColor: '#0D47A1',
            bgGradient: 'linear-gradient(to bottom right, #0D47A103, #1565C00a)'
        },
        howItWorks: {
            primary: '#0D47A1',
            chipBackground: '#0D47A11a',
            connectionLine: 'linear-gradient(90deg, #90CAF9, #64B5F6, #42A5F5)',
            ctaText: '#0D47A1',
            ctaButton: 'linear-gradient(to bottom right, #0D47A1, #1565C0)',
            ctaButtonHover: '#0A3D7A'
        },
        integrations: {
            primary: '#0D47A1',
            chipBackground: '#0D47A11a',
            cardHoverBorder: '#0D47A1',
            titleHoverColor: '#0D47A1'
        },
        workContent: {
            bgGradient: 'linear-gradient(to bottom right, #0D47A103, #1565C00a)',
            chipGradient: 'linear-gradient(to bottom right, #0D47A1, #1565C0)',
            topBorderGradient: 'linear-gradient(to right, #0D47A1, #1565C0)',
            cardHoverBorder: 'rgba(13, 71, 161, 0.2)'
        },
        cta: {
            bgColor: '#0D47A1',
            primaryButtonBg: 'white',
            primaryButtonColor: '#0D47A1',
            secondaryButtonBorder: 'white',
            secondaryButtonColor: 'white'
        }
    },


    pricingPage: {
        primary: "#0D47A1",
        primaryPassive: '#d32f2f',
        background: "#0D47A11a",
        isOutOfStockHover: '#1565C0',
        backgorundGradient: "linear-gradient(to bottom right, #1565C0, #0D47A1)",
        ctaBoxShadow: "0 20px 40px rgba(13, 71, 161, 0.25)"
    },


    productsPage:{
        primary:"#0D47A1",
        backgroundGradient:"linear-gradient(to bottom right, #1565C0, #0D47A1)",
        tabBackgroundGradient:"linear-gradient(to right, #1565C0, #0D47A1)",
        hoverBorderColor: "#0D47A196"
    },

    aboutPage:{
        backgorundGradient:"linear-gradient(to bottom right, #1565C0, #0D47A1)",
        border:"1px solid #0D47A1"
    },

    iletisimPage:{
        primary: "#0D47A1",
        secondary: "#1565C0",
        backgorundGradient:"linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)"
    },

    applyPage: {
        primary: "#0D47A1",
    },

    eImzaBasvuruPage: {
        primary: "#0D47A1",
         primaryHover: "#1565C0",
         secondaryColor: "#1565C0",
        chipBackgroundGradient:"linear-gradient(to bottom right, #1565C0, #0D47A1)"
    },

    signInPage: {
        dealerBoxBackground: "rgba(13, 71, 161, 0.06)",
        dealerBoxBorder: "rgba(13, 71, 161, 0.2)",
        dealerBoxHoverBackground: "rgba(13, 71, 161, 0.1)",
        dealerBoxHoverBorder: "rgba(13, 71, 161, 0.4)",
        dealerBoxShadow: "0 4px 12px rgba(13, 71, 161, 0.2)"
    },


    // İletişim bilgileri
    contact: {
        phone: "+90 850 244 45 50",
        address: "Aydın, Türkiye",
       email: "iletisim@ronesansbilisim.com.tr",
         kep: "ronesansinovasyonvemuhendislik@hs01.kep.tr",
         destekEmail:"iletisim@ronesansbilisim.com.tr"
    },
    // Sosyal medya
    social: {
        facebook: "https://www.facebook.com/people/R%C3%B6nesans-Bili%C5%9Fim/61588608692990/",
        twitter: "https://x.com/BilisimRonesans",
        instagram: "https://www.instagram.com/ronesansbilisim/",
        linkedin: "https://www.linkedin.com/in/r%C3%B6nesans-bili%C5%9Fim-86b7733b2/",
    },

    // SEO
    meta: {
        title: "SüperDernek | Resmi Altyapılı Dijital Dernek Yönetim Platformu",
        description: "SüperDernek ile derneğinizi dijitale taşıyın. Üye yönetimi, aidat takibi, bağış sistemi, web sitesi, e-imza, KEP entegrasyonu ve mobil uygulama ile tüm dernek süreçlerini tek platformdan yönetin.",
        keywords: "dernek yönetim sistemi, dernek yazılımı, e-imza dernek sistemi, kep entegrasyonu, aidat takibi, dernek üye yönetimi, dijital dernek yönetimi, dernek otomasyonu",
        ogImage: "/superdernek-og-image.jpg"
    },

    // Özellikler
    features: {
        showBlog: true,
        showDealership: true,
        showPricing: true,
        showOrderTrack: true
    }
};
